import { Box, Typography } from "@mui/material";

type Props = {
  currentBlock: any;
};

const TitleField = ({ currentBlock }: Props) => {
  const label = currentBlock?.label;

  return (
    <Box sx={{ textAlign: "center" }}>
      <Typography
        sx={{
          fontSize: 24,
          fontWeight: 500,
          color: "text.primary",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};
export default TitleField;
